import { Component } from '@angular/core';

@Component({
    selector: 'app-permission-unauthorized',
    templateUrl: './permission-unauthorized.component.html',
    styleUrls: ['./permission-unauthorized.component.scss'],
    standalone: false
})
export class PermissionUnauthorizedComponent {

}
